<template>
  <section class="chat-wrapper">
    <div class="chat-members-wrapper">
      <div class="row chat-members-header">
        <div class="col">
          <div class="row chat-members-title">
            <div class="col-11">
              <span>New Chat Session</span>
            </div>
            <div class="col-1">
              <div class="chat-close" @click="closeNew"><i class="fas fa-times"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row chat-members-content">
        <div class="chat-members-new">
          <div class="row">
            <div class="col">
              <div class="input-group">
                <span class="input-group-text">Title:<span class="text-danger ml-1">*</span></span>
                <input name="title" v-model="subject" class="form-control" maxlength="50" placeholder="title" />
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <multiselect
                v-model="selected"
                id="searchMembers"
                label="label"
                track-by="guid"
                placeholder="invite a member (type to search)"
                open-direction="bottom"
                :options="foundMembers"
                class="w-100 multiselect__tags_add"
                :multiple="false"
                :max-height="500"
                :options-limit="100"
                :limit="5"
                :internal-search="false"
                :close-on-select="true"
                :show-no-results="false"
                :hide-selected="false"
                :loading="isLoading"
                @search-change="searchForMembers"
                @select="selectedMember"
              >
              </multiselect>
              <ul class="chat-members-list">
                <li v-for="item of currentMembers" :key="item.guid">
                  <div class="row chat-members-record">
                    <div class="col">
                      <span>{{ cleanName(item) }}</span>
                    </div>
                    <div class="col-1 chat-members-remove">
                      <a v-if="item.status === 'added'" href="#" @click="removeMember(item)" class="chat-remove" tabindex="-1">
                        <i class="fas fa-times text-danger"></i>
                      </a>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <dt-message v-model="notice" :timeout="2000" class="alert alert-warning m-3" />
        </div>
      </div>
      <div ref="msgFooter" class="chat-messages-footer">
        <!-- message bar (type new message and emojis) -->
        <div class="row chat-messages-footer-row">
          <div class="col chat-messages-message-area">
            <textarea v-model="newMessage" ref="newMessage" placeholder="type message..." class="chat-messages-message"></textarea>
            <div class="chat-emoji" @click="toggleEmoji">
              <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                />
              </svg>
            </div>
          </div>
          <div class="col-1 chat-message-send">
            <!-- send a message -->
            <a href="#" title="send message" @click="send">
              <i class="fas fa-share-square"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- emoji widget -->
    <emoji-widget ref="emojiWidget" @emoji="appendEmoji" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import EmojiWidget from '@/components/chat/elements/emoji/emoji-widget.vue'
import DtMessage from '@/components/utilities/form/dt-message'
export default {
  name: 'chat-new',
  components: {
    Multiselect,
    EmojiWidget,
    DtMessage
  },
  data() {
    return {
      actionNew: null,
      subject: null,
      newMessage: '',
      selectedContacts: null,
      isLoading: false,
      notice: null,
      selected: null,
      selectedMembers: [],
      foundMember: null
    }
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    ...mapGetters('chat', ['foundMembers', 'channelInfo']),
    isVisible: {
      get() {
        return this.value
      }
    },
    currentMembers() {
      let _members = []
      if (this.selectedMembers) {
        _members = this.selectedMembers
      }
      return _members
    },
    isChanged() {
      let _is = false
      if (this.selectedMembers) {
        let found = this.selectedMembers.find(x => x.status === 'added')
        if (found) {
          _is = true
        }
      }
      return _is
    },
    isOwner() {
      let _is = false
      if (this.channelInfo) {
        if (this.channelInfo.type.substring(0, 5) === 'adhoc' && this.channelInfo.owner !== null) {
          if (this.channelInfo.owner === this.profile.guid) {
            _is = true
          }
        }
      }
      return _is
    }
  },
  methods: {
    ...mapActions('chat', ['createChannelSendMessage', 'searchChatUsers']),
    closeNew() {
      this.$emit('closeNew')
    },
    toggleEmoji() {
      this.$refs.emojiWidget.toggle()
    },
    appendEmoji(emoji) {
      this.newMessage += emoji
    },
    cleanName(item) {
      return `${item.name} (${item.email})`
    },
    searchForMembers: _.debounce(async function(search) {
      await this.fetchMembers(search)
    }, 350),
    async fetchMembers(search) {
      this.isLoading = true
      if (search.trim() !== '') {
        await this.searchChatUsers({
          firm: this.profile.firm,
          search: search
        })
        this.isLoading = false
      }
    },
    selectedMember() {
      this.$nextTick(() => {
        this.isLoading = false
        console.log('Selecting Member...', this.selected)
        if (this.selected && this.foundMembers) {
          let there = this.selectedMembers.find(x => x.guid === this.selected)
          if (!there) {
            let found = this.foundMembers.find(x => x.guid === this.selected.guid)
            console.log('Selected Member', {
              found: found,
              selected: this.selected,
              selectedMembers: this.selectedMembers
            })
            this.selectedMembers.push({
              user: found.user.toString(),
              fileAs: found.fileAs,
              email: found.username,
              name: found.name,
              guid: found.guid,
              status: 'added',
              isActive: true
            })
          }
          this.selected = null
          // this.$refs.searchMembers.clearSearch()
          // this.$refs.searchMembers.clear()
        }
      })
    },
    removeMember(item) {
      console.log('Remove Member', item)
      if (this.selectedMembers) {
        this.selectedMembers = this.selectedMembers.filter(x => x.guid !== item.guid)
      }
    },
    async send() {
      this.notice = null
      if (this.subject) {
        if (this.subject.trim() !== '') {
          if (this.newMessage.trim() !== '') {
            if (this.selectedMembers) {
              if (this.selectedMembers.length > 0) {
                let guids = []
                guids.push(this.profile.guid)
                this.selectedMembers.forEach(member => {
                  guids.push(member.guid)
                })
                let info = {
                  memberCount: guids.length,
                  members: guids,
                  name: this.subject,
                  type: 'adhoc',
                  url: 'new',
                  message: this.newMessage
                }
                let channel = await this.createChannelSendMessage(info)
                this.newMessage = ''
                this.$emit('sent', channel)
              } else {
                this.notice = 'Please supply at least one recipient'
              }
            } else {
              this.notice = 'Please supply at least one recipient'
            }
          } else {
            this.notice = 'Please supply a message'
          }
        } else {
          this.notice = 'Please supply a subject'
        }
      } else {
        this.notice = 'Please supply a subject'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chat/elements/chat-new.vue